import SubSectionRow from '@shared/components/core/headers/SubSectionRow';
import { SubSectionContentStack } from '@shared/components/core/layouts/CommonLayoutStyles';
import { ContentTitleThin } from '@shared/components/core/text/ContentTypography';
import { TitleSmall } from '@shared/components/core/text/Typography';
import ActivateLicenseCard from '@shared/components/license/ActivateLicenseCard';
import ExpiredLicenseCard from '@shared/components/license/ExpiredLicenseCard';
import SplashLoader from '@shared/components/loading/SplashLoader';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteUserSection from './DeleteUserSection';
import EmailPreferencesSection from './EmailPreferencesSection';
import PasswordResetSection from './PasswordResetSection';
import UserPreferencesSection from './UserPreferencesSection';

export default function AccountSettingPageContent() {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const currentUser = useCurrentUserStore((state) => state.currentUser);
    const hasNoOrgMemberships = useCurrentUserStore((state) => state.hasNoOrgMemberships);

    useEffect(() => {
        const fetchUserData = async () => {
            await useCurrentUserStore.getState().loadCurrentUser();
            setIsLoading(false);
        };

        fetchUserData();
    }, []);

    if (isLoading) {
        return <SplashLoader />;
    }

    return (
        <>
            <SubSectionContentStack>
                <ContentTitleThin as="p">
                    {t('common:account.usernameLabel')} <TitleSmall as="span">{currentUser?.username}</TitleSmall>
                </ContentTitleThin>
                <ContentTitleThin as="p">
                    {t('common:account.emailLabel')} <TitleSmall as="span">{currentUser?.email}</TitleSmall>
                </ContentTitleThin>
            </SubSectionContentStack>

            {hasNoOrgMemberships ? <ActivateLicenseCard /> : <ExpiredLicenseCard />}
            <PasswordResetSection />
            <EmailPreferencesSection />
            <UserPreferencesSection />
            <SubSectionRow title={t('dangerZone')} />
            <DeleteUserSection />
        </>
    );
}
